import { Fragment } from "react";
import { Alert, Box, IconButton, Stack, Typography } from "@mui/material";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import BaseLayout from "../../layouts/BaseLayout";
import Timeline from "../../components/ServiceTimeline";
import ServiceCallToActions from "./ServiceCallToActions";
import PatientPortalStatus from "./PatientPortalStatus";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useTreatment from "../../api/useTreatment";

function ServiceSingle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { api } = useOutletContext();
  const { isLoading, error, data: serviceData, mutate } = useTreatment(id);

  if (error) {
    return (
      <BaseLayout>
        <Alert severity="error">{error.message}</Alert>
      </BaseLayout>
    );
  }

  if (isLoading || !serviceData) {
    return <BaseLayout>Loading...</BaseLayout>;
  }

  const first_arrived_on = serviceData[0]?.fit_on;
  const data =
    serviceData.map((x) => ({ ...x, first_arrived_on })).slice(-1)[0] || {};

  const fitabilityIssue = !data.fitable && data.billing_channel === "cash-pay";

  return (
    <BaseLayout>
      <Stack spacing={2}>
        <Typography variant="h3" align="center">
          {data.patient_name}
        </Typography>
        <Box mt={2}>
          <Alert
            variant="outlined"
            severity="info"
            icon={false}
            action={
              <IconButton
                size="small"
                onClick={() => navigate(`/patients/${data.eoc_id}`)}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            }
          >
            Viewing a service item, for patient:
          </Alert>
        </Box>
        {fitabilityIssue && (
          <Alert severity="error">
            Patient cannot be fit: {data.fitable_memo}
          </Alert>
        )}
        {/*
         * Reps can neither send the rental agreement nor mint a payment link
         * any more — the patient does both for themselves in the portal, and
         * the agreement does not exist until they sign it. So the whole area is
         * a status read whose only call to action is pointing the patient at
         * the portal. `patient_portal` is null for work-comp, which is what
         * keeps this off pages where it would mean nothing.
         */}
        <PatientPortalStatus
          portal={data.patient_portal}
          email={data.patient_email}
          phone={data.patient_phone}
        />
        <ServiceCallToActions
          cycle={data}
          api={api}
          refresh={() => mutate()}
          actionsDisabled={data.order_status === "postponed"}
        />
        {serviceData.map((d) => {
          return (
            <Fragment key={d.id}>
              <Box sx={{ width: "100%" }} mb={0}>
                <Typography align="center" variant="h5">
                  Unit: {d.serial_num}
                </Typography>
              </Box>
              <Timeline cycle={d} />
            </Fragment>
          );
        })}
      </Stack>
    </BaseLayout>
  );
}

export default ServiceSingle;
